export default __webpack_public_path__ + "static/media/Marca_Transfácil_sem tagline branca.9bb2349a.png";